import { Link } from 'react-router-dom';

interface GuideAppHeaderProps {
  step: 'start' | 'question' | 'analyzing' | 'result';
  title?: string;
  currentQuestion?: number;
  totalQuestions?: number;
  onBack?: () => void;
  onRetry?: () => void;
}

export default function GuideAppHeader({
  step,
  title = '가이드',
  currentQuestion,
  totalQuestions,
  onBack,
  onRetry,
}: GuideAppHeaderProps) {
  return (
    <header className="sticky top-0 z-50 h-[50px] bg-white/95 backdrop-blur-sm border-b border-line-divider flex items-center px-4 flex-shrink-0 hidden">
      <div className="w-10 flex items-center justify-start">
        {(step === 'start' || step === 'result') && (
          <Link
            to="/"
            className="w-9 h-9 flex items-center justify-center rounded-full hover:bg-bg-alt transition-colors cursor-pointer"
            aria-label="홈으로"
          >
            <i className="ri-home-4-line text-label-neutral text-lg"></i>
          </Link>
        )}
        {(step === 'question' || step === 'analyzing') && onBack && (
          <button
            onClick={onBack}
            className="w-9 h-9 flex items-center justify-center rounded-full hover:bg-bg-alt transition-colors cursor-pointer"
            aria-label="이전"
          >
            <i className="ri-arrow-left-line text-label-neutral text-lg"></i>
          </button>
        )}
      </div>

      <div className="flex-1 text-center">
        <span className="text-[17px] font-semibold text-label-normal">{title}</span>
      </div>

      <div className="w-10 flex items-center justify-end">
        {step === 'question' && currentQuestion && totalQuestions && (
          <span className="text-[13px] text-label-assistive tabular-nums font-medium">
            {currentQuestion}/{totalQuestions}
          </span>
        )}
        {step === 'result' && onRetry && (
          <button
            onClick={onRetry}
            className="w-9 h-9 flex items-center justify-center rounded-full hover:bg-bg-alt transition-colors cursor-pointer"
            aria-label="다시하기"
          >
            <i className="ri-refresh-line text-label-neutral text-lg"></i>
          </button>
        )}
      </div>
    </header>
  );
}